import {Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {GlobalService} from '../../../../global.service';
import {EventsService} from '../../../events.service';
import {ActivatedRoute} from '@angular/router';

import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarComponent,
  PerfectScrollbarDirective
} from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-yalla-awc-tournaments',
  templateUrl: './yalla-awc-tournaments.component.html',
  styleUrls: ['./yalla-awc-tournaments.component.css']
})
export class YallaAwcTournamentsComponent implements OnInit {
  RankGroups = [];
  panelOpenState = false;

  public config: PerfectScrollbarConfigInterface = {
    // suppressScrollX:true
  };
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;
  notStarted = false;
  load = true;

  constructor(public globalService: GlobalService, private activeRoute: ActivatedRoute, public eventService: EventsService) {
  }

  ngOnInit() {
    this.activeRoute.params.subscribe(param => {
      this.changeRoute(param['code']);
    });
    this.eventService.getTree('rNXcZIT4l6ii', 1).subscribe((res) => {
      console.log(res.tournamentTree);
      this.notStarted = false;

      this.RankGroups = res.tournamentTree.groups;
      this.RankGroups.forEach((group, index) => {
        group['bo3'] = res.tournamentTree.bo3 ? res.tournamentTree.bo3 : false;
        group['are_participants_selected'] = false;
        group.participants.forEach((participant, i) => {
          participant['is_saving'] = false;
          participant['is_selected'] = false;
          if (participant.tournament_participant) {
            if (participant.tournament_participant.is_dummy) {
              participant.original = {
                ...participant.original,
                participant_name: participant.tournament_participant.participant_name,
                participation_number: participant.tournament_participant.participation_number,

              };
            }
            participant.required_inputs = participant.tournament_participant.required_inputs;
          }
        });
      });

      this.load = false;
    }, (error) => {
      console.log(error);
      this.load = false;

      this.notStarted = true;
    });
  }


  changeRoute(param) {
    console.log(param);
    this.eventService.loadEventTournaments = true;
    this.eventService.getEventTournaments('yalla-arabian-cup', 1, 'pubg').subscribe(res => {
      console.log(res);
      this.eventService.eventTournaments.next(res);
      this.eventService.loadEventTournaments = false;
    }, error => {
      this.eventService.eventTournaments.next({data: []});
      this.eventService.loadEventTournaments = false;
    });
  }

}
